import { TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import { useField } from 'formik';
import React, { ComponentType } from 'react';

import { Dropdown } from './Dropdown';
import { useFieldSchema } from './Schema';

export type InputFieldProps = TextFieldProps & {
  name: string;
  component?: ComponentType<TextFieldProps & any>;
  [key: string]: any;
};

export const InputField = ({
  component = TextField,
  select,
  ...props
}: InputFieldProps) => {
  const { name, type } = props;
  const [field, meta] = useField(name);
  const error = meta.touched && meta.error;
  const schema = useFieldSchema(name);

  const value = {
    value: field.value || '',
    checked: type === 'checkbox' && !!meta.value
  };

  const Component = select ? Dropdown : component;

  return (
    <Component
      {...schema}
      {...props}
      {...field}
      {...value}
      error={!!error}
      helperText={error ? String(error).trim() : props.helperText}
    />
  );
};
